import React, {useState, Fragment, useEffect} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import { dateSorter } from "root/Tables/TableSorters";
import {
  defaultPaginationOptions,
  defaultTableHeaderStyles,
} from "./BaseTableComponents";

import './TableTeachers.scss'
import {customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle} from "root/Tables/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";


const TablePupils= ({loading, data, showPepColumns }) =>
{
  const onClickEdit = ( school_id ) =>
  {
    clickHandler (school_id, 'edit', onDialogClosed );
  }

  const yearFormatter = (cell, row, rowIndex, formatExtraData) => {
    return row.year_name;
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    firstname: {borderRadius: defaultTopLeftCellStyle, width: "18vw"},
    last_pep_date: {borderRadius: defaultTopRightCellStyle, textAlign: 'left', width: "10vw"}
  });

  const pepColumns = showPepColumns ? [
          {
            dataField: "date_from",
            text: "From",
            sort: true,
            sortFunc: dateSorter,
            headerStyle: headerStyle
          },
      {
        dataField: "last_pep_date",
        text: "Last PEP",
        sort: true,
        sortFunc: dateSorter,
        headerStyle: headerStyle
      } ] : [] ;

  const getColumns = () => {
    const columns = [
      {
        dataField: "firstname",
        text: "First Name",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "surname",
        text: "Surname",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "order_by",
        text: "Year",
        sort: true,
        formatter: yearFormatter,
        headerStyle: headerStyle
      },
      ...pepColumns
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, []);

  const tableContent = () =>
  {
    return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions}/>

  }

  return loading === true ? <SpinnerDiv/> : tableContent();
};

export default TablePupils;
